import { AdminApi } from './';

export class AuthApi {
    static login (data) {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
            ...AdminApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }

    static logout () {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/logout`, {
            ...AdminApi.PostDefualtMethod
        });
    }

    static setup2FA() {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/2fa/setup`, {
            ...AdminApi.PostDefualtMethod
        });
    }

    static verifySetup2FA() {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/2fa/setup/verify`, {
            ...AdminApi.PostDefualtMethod
        });
    }

    static verify2FA(data) {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/2fa`, {
            ...AdminApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }

    static delete2FA() {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/2fa`, {
            ...AdminApi.PostDefualtMethod,
            method: 'DELETE'
        });
    }

    /**
     * check if admin logged in (if response status != 403)
     */
    static isAdminLoggedIn () {
        return AdminApi.getAllAdmins();
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.js